import { graphql, useStaticQuery } from 'gatsby';

export type SiteUrlQueryResponse = {
  site?: {
    siteMetadata?: {
      siteName?: string;
      siteUrl?: string;
    };
  };
};

const useSiteMetadata = () => {
  const data = useStaticQuery<SiteUrlQueryResponse>(graphql`
    {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const siteName = data?.site?.siteMetadata?.siteName || '';
  const siteUrl = data?.site?.siteMetadata?.siteUrl || '';

  return { siteUrl, siteName };
};

export default useSiteMetadata;
